import React, { useEffect, useState } from "react";
import { useOnChangeWatcher } from "../models/useOnChangeWatcher";
import Floor from "../models/Floor";
import Room from "../models/Room";

import Logger from "../Logger";
import CabinetDialog from "../modelDialogs/CabinetDialog";

const logger = new Logger();

export default function CabinetSelection(props: {
  style?: any;
  forRoom?: boolean;
  floorCabinetName?: string;
  floorRoom?: Floor | Room;
  value?: string;
  onChange: (id: string) => void;
  onChangeAfterCreation?: () => boolean;
  requestRow?: boolean;
  fromProeprtyView?: boolean;
}) {
  var {
    style,
    floorRoom,
    value,
    onChange,
    onChangeAfterCreation,
    forRoom,
    floorCabinetName,
    requestRow,
    fromProeprtyView: openNewCabinetCreation,
  } = props;

  const selectionElmements: any = [];
  const dropdownElements = new Array<{ value: string; label: string }>();
  const [defvalue, setDefValue] = useState(floorRoom?.cabinetId || "create"); // no itx

  useEffect(() => {
    if (floorRoom?.cabinetId) {
      let element = document.getElementById("CabinetSelectionSelect") as any;
      if (element?.value) {
        element.value = floorRoom.cabinetId;
      }
    }
  }, [defvalue]);

  useOnChangeWatcher(floorRoom, (changedProperty) => {
    if (changedProperty == "cabinetId") {
      setDefValue(floorRoom?.cabinetId || "create"); // no itx
    }
    return true;
  });

  if (requestRow) {
    selectionElmements.push(
      <option id="request" key="sel">
        {state.translate("CabinetSelection.selectionElementRequest", "Bitte Wählen Sie einen Schaltschrank aus")}
      </option>,
    );
    dropdownElements.push({
      value: "request", // no itx
      label: state.translate("CabinetSelection.selectionElementRequest", "Bitte Wählen Sie einen Schaltschrank aus"),
    });
  }
  if (forRoom) {
    if (floorCabinetName == undefined) {
      floorCabinetName = "";
    }
    dropdownElements.push({
      value: "floor", // no itx
      label: `${state.translate(
        "CabinetSelection.selectionElementFloor",
        "Von Etage übernehmen ",
      )}  ${floorCabinetName}`,
    });
    selectionElmements.push(
      <option
        value="floor" // no itx
        key="floor" // no itx
      >
        {`${state.translate("CabinetSelection.selectionElementFloor", "Von Etage übernehmen ")}  ${floorCabinetName}`}
      </option>,
    );
  } else {
    // dropdownElements.push({
    //   value: "start", // no itx
    //   label: state.translate("CabinetSelection.selectionElementStart", "Wähle einen Schaltschrank aus"),
    // });
    // selectionElmements.push(
    //   <option
    //     value="start" // no itx
    //     key="sel" // no itx
    //   >
    //     {state.translate("CabinetSelection.selectionElementStart", "Wähle einen Schaltschrank aus")}
    //   </option>,
    // );
  }

  ///////////////////////////////////////////////////////////////////////
  useOnChangeWatcher(state.cabinets);
  state.cabinets.sortBy("tagOrName").forEach((cabinet) => {
    if (cabinet.id) {
      var label: any = `${cabinet.fullTag}  ${cabinet.name}`;
      if (cabinet.name == "" && cabinet.fullTag == "") {
        label = cabinet.treeViewModel?.getTitlePostfix();
      }
      // dropdownElements.push({
      //   value: `${cabinet.id}`,
      //   label: label,
      // });
      selectionElmements.push(
        <option value={cabinet.id} key={cabinet.id}>
          {label}
        </option>,
      );
    }
  });
  if (openNewCabinetCreation) {
    dropdownElements.push({
      value: "create2", // no itx
      label: state.translate("CabinetSelection.selectionElementCreate2", "erstelle einen neuen Schaltschrank"),
    });
    selectionElmements.push(
      <option
        value="create2" // no itx
        key="create" // no itx
      >
        {state.translate("CabinetSelection.selectionElementCreate2", "erstelle einen neuen Schaltschrank")}
      </option>,
    );
  } else {
    dropdownElements.push({
      value: "create", // no itx
      label: state.translate("CabinetSelection.selectionElementCreate", "erstelle einen neuen Schaltschrank"),
    });
    selectionElmements.push(
      <option
        value="create" // no itx
        key="create" // no itx
      >
        {state.translate("CabinetSelection.selectionElementCreate", "erstelle einen neuen Schaltschrank")}
      </option>,
    );
  }

  let defaultValue = "start"; // no itx
  if (floorRoom?.cabinetId) {
    defaultValue = floorRoom?.cabinetId;
  } else if (value) {
    defaultValue = value;
  } else if (forRoom) {
    defaultValue = `floor`;
  } else if (selectionElmements.length <= 2 && !openNewCabinetCreation) {
    defaultValue = "create"; // no itx
    onChange(defaultValue);
  } else if (state.cabinets.size >= 1) {
    defaultValue = state.cabinets.sortBy("tag")[0].id;
    onChange(defaultValue);
  }

  // let defaultLabelElement = "";
  // dropdownElements.forEach((elm) => {
  //   if (elm.value == defaultValue) {
  //     defaultLabelElement = elm.label;
  //   }
  // });

  function onValueChangeOrBlur(value: string, ev?: any) {
    ev?.stopPropagation();
    onChange(value);
    if (value == "create2") {
      state.dialogManager.openDialog(
        <CabinetDialog parent={state.cabinets} floorRoom={floorRoom} afterCreation={onChangeAfterCreation} />,
      );
      if (ev) {
        ev.target.value = defaultValue;
      }
    }
  }

  return (
    <select
      className="select"
      id="CabinetSelectionSelect"
      style={{
        minWidth: "70px",
        width: "max-content",
        borderColor: "var(--border-color)",
        ...style,
      }}
      defaultValue={defaultValue}
      // for all other
      // onClick={(ev: any) => {
      //   ev.stopPropagation();
      //   onChange(ev.target.value);
      //   if (value == "create2") {
      //     state.dialogManager.openDialog(
      //       <CabinetDialog parent={state.cabinets} floorRoom={floorRoom} />,
      //     );
      //     ev.target.value = defaultValue;
      //   }
      // }}
      // for apple
      onBlur={(ev) => {
        const value = ev.target.value;
        onValueChangeOrBlur(value);
      }}
    >
      {selectionElmements}
    </select>
  );
}
